import React from 'react'
import { Typography } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import { CORRECTION_WINDOW_HOURS } from 'constants/railcarVisits'

// Status changes drive the monthly railcar billing reports, so operators need to know that a
// mistake is only free to fix for a limited time. Kept permanently visible rather than shown as
// a toast, because the people who need it are not the people who trigger it.
const CorrectionWindowNotice = () => (
  <Alert severity="info" style={{ margin: '0 10px 16px' }}>
    <AlertTitle>Status changes are billed &mdash; you have {CORRECTION_WINDOW_HOURS} hours to fix a mistake</AlertTitle>
    <Typography variant="body2" component="div">
      Marking a railcar <strong>Not At Facility</strong> closes out its stay at this terminal, and that release is
      what the month-end invoice is built from. Marking one <strong>On Track - Empty</strong> records that it emptied
      here.
      <ul style={{ margin: '8px 0 0', paddingLeft: '20px' }}>
        <li>
          Emptied the wrong car? Put it back to an on-track status within {CORRECTION_WINDOW_HOURS} hours and
          nothing is billed.
        </li>
        <li>
          Released the wrong car? Put it back to the status it had within {CORRECTION_WINDOW_HOURS} hours. If it was
          already empty, choose <strong>On Track - Empty</strong> &mdash; putting an emptied car back to a loaded
          status counts as a new arrival, not an undo.
        </li>
        <li>
          Importing a file? Any car in it that was released in the last {CORRECTION_WINDOW_HOURS} hours is put back
          on site and its release is cancelled, so take released cars out of the file before you import it.
        </li>
      </ul>
      After {CORRECTION_WINDOW_HOURS} hours the change is treated as real and counts on the month-end report. Tell
      the Controller so it can be adjusted.
    </Typography>
  </Alert>
)

export default CorrectionWindowNotice
